import PayForTarif from './PayForTarifContainer';
export default PayForTarif;



// WEBPACK FOOTER //
// ./src/components/Payments/PayForTarif/index.js